// # Auth Routes Configuration
import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import SignupMain from '../../landing/pages/signup/SignupMain';
import SignupPersonal from '../../landing/pages/signup/SignupPersonal';
import SignupAcademic from '../../landing/pages/signup/SignupAcademic';
import SignupPhoto from '../../landing/pages/signup/SignupPhoto';
import { useAuthStore } from '../../auth/state';

const SignupRoutes = () => {
  const { isAuthenticated, isProfileComplete } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  // # Handle resume signup
  useEffect(() => {
    if (isAuthenticated && !isProfileComplete) {
      // # Get the last signup step from localStorage (more persistent than sessionStorage)
      const lastStep = localStorage.getItem('lastSignupStep');
      const currentPath = location.pathname.split('/').pop();
      
      const stepRoutes = {
        '2': '/signup/personal',
        '3': '/signup/academic',
        '4': '/signup/photo'
      };

      // # If user is on main signup page but has a saved step, redirect to that step
      if (currentPath === 'signup' && lastStep && stepRoutes[lastStep]) {
        navigate(stepRoutes[lastStep]);
      }
    }
  }, [isAuthenticated, isProfileComplete, location, navigate]);

  // # Only protect dashboard access, not signup steps
  const ProtectedSignupStep = ({ children }) => {
    // # Only redirect to dashboard if profile is complete
    if (isAuthenticated && isProfileComplete) {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  };

  return (
    <Routes>
      <Route 
        path="/" 
        element={
          <ProtectedSignupStep>
            <SignupMain />
          </ProtectedSignupStep>
        } 
      />
      <Route 
        path="/personal" 
        element={<SignupPersonal />} 
      />
      <Route 
        path="/academic" 
        element={<SignupAcademic />} 
      />
      <Route 
        path="/photo" 
        element={<SignupPhoto />} 
      />
      <Route path="*" element={<Navigate to="/signup" replace />} />
    </Routes>
  );
};

export default SignupRoutes;
